/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meal-nutrition.reducer';

export const MealNutritionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mealNutritionEntity = useAppSelector(state => state.mealNutrition.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mealNutritionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mealNutrition.detail.title">MealNutrition</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.id">Id</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.active">Active</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.microSec}</dd>
          <dt>
            <span id="total">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.total">Total</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.total}</dd>
          <dt>
            <span id="rdi">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.rdi">Rdi</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.rdi ? 'true' : 'false'}</dd>
          <dt>
            <span id="dailyTotal">
              <Translate contentKey="tinyMedicRestApp.mealNutrition.dailyTotal">Daily Total</Translate>
            </span>
          </dt>
          <dd>{mealNutritionEntity.dailyTotal}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealNutrition.meal">Meal</Translate>
          </dt>
          <dd>{mealNutritionEntity.meal ? mealNutritionEntity.meal.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mealNutrition.nutrition">Nutrition</Translate>
          </dt>
          <dd>{mealNutritionEntity.nutrition ? mealNutritionEntity.nutrition.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/meal-nutrition" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meal-nutrition/${mealNutritionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MealNutritionDetail;
